import { HttpErrorResponse, HttpRequest } from '@angular/common/http';
import { UiErrorParser } from '../ui-error-parser';
import { SICOM_PATHS } from 'src/sicom-paths';

export class ReceitaErrorParser extends UiErrorParser {
    private receitaUrl = SICOM_PATHS.consulta.receita.base;

    override verifyContext(error: HttpErrorResponse, req: HttpRequest<unknown>): boolean {
        return req.url.includes(this.receitaUrl) && error.status !== 0;
    }

    override beforeTextBuild(_error: HttpErrorResponse, _req: HttpRequest<unknown>): void {
        this.setMessageStart('Não foi possível');
        this.setMethod('encontrar');
        this.setTarget('o registro');
    }

    override errorComplement(_error: HttpErrorResponse, _req: HttpRequest<unknown>): string {
        return 'Verifique o registro informado.';
    }
}
